import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { RootState, useAppDispatch as useDispatch } from 'store/store';
import {
  getQuestion,
  clearErrors,
  clearQuestion,
  getAnswer,
  clearAnswer,
} from 'store/question';

// import NcImage from 'components/NcImage/NcImage';
import { AnswerDataType, QuestionDataType } from 'data/types';
import Layout from './layout';

const PageSingle = () => {
  const dispatch = useDispatch();
  const { id = '' } = useParams<{ id: string }>();

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(getAnswer(id));
    };

    fetchData();

    return () => {
      dispatch(clearAnswer());
      dispatch(clearErrors());
    };
  }, [dispatch, id]);

  const questionSlice = useSelector((state: RootState) => state.question);

  const answer: AnswerDataType = questionSlice.answer!;

  return (
    <Layout answer={answer}>
      <div></div>
    </Layout>
  );
};

export default PageSingle;
